import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

type LogInMutationVariable = {
  snsId:string;
};

export const usePostLogIn = (
  options?: UseMutationOptions<any, AxiosError, LogInMutationVariable>
) => {
  return useMutation<any, AxiosError, LogInMutationVariable>(
    async ({ snsId }) => {
      try {
        const response = await request.post('/login', {
          snsId
        });

        return response
      } catch(e){
        //@ts-ignore
        const result = e.response;
        return result
      }
    },
    {
      ...options
    }
  )
}

export default usePostLogIn;